import React, { Component } from 'react';
import { Spin, Button, Modal, message, Tooltip, Icon, Tabs, Form } from 'antd';
import { connect } from 'dva';
import router from 'umi/router';
import moment from "moment";
import FormCreate from '../../../../../components/FormCreate/index';
import { getLabelStrData } from '../../utils/convertData';
import Container from '../../../../../components/Container';
import ArticleTable from './components/ArticleTable';
import SelectList from './components/SelectList';
import { getAppCode, GetQueryString } from '../../utils/utils';
import styles from './index.less';

const { confirm } = Modal;
const { TabPane } = Tabs;
const {
  SelectUserVersion4,
  RangeSelectUser,
  FormSelect,
  DateAndTime,
  FormRadioGroup,

} = FormCreate;

@Form.create()

@connect(({ microToPublic, user }) => ({
  ...microToPublic,
  currentUser: user.currentUser,
}))

class BatchPush extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: '1',
      pushTime: moment().add(2, "hours"),
      isTiming: 0,
      groupInfoList: [],
      orgRelInfoList: [],
      tagInfoList: []
    };

  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'microToPublic/reset',
    });
  }

  renderTabTitle = (activeKey, title, index) => {
    return (
      <span>
        <i
          className={
            activeKey === index ? 'common-icon-style active-style' : 'common-icon-style icon-style'
          }
        >
          {index}
        </i>
        {title}
      </span>
    );
  };

  changeTab = activeKey => {
    this.setState({ activeKey });
  };


  confirmPush = () => {
    const { selectedRow, form } = this.props;
    const selectedNum = selectedRow.length;
    const { validateFields, getFieldValue } = form;
    const { groupInfoList, orgRelInfoList, tagInfoList } = this.state;
    const that = this;

    if (selectedNum === 0) {
      message.error('请选择文章');
    } else {
      validateFields(err => {
        if (!err) {

          if (getFieldValue('selectIdType') === 2) {
            const orgArr = [...groupInfoList, ...orgRelInfoList];
            if (orgArr.length === 0 || tagInfoList.length === 0) {
              return message.error('请选择推送范围');
            }
          }

          confirm({
            title: '确定发送文章提醒吗',
            content: '',
            okText: '确定',
            cancelText: '取消',
            className: styles.confirmModal,
            onOk() {
              that.fetchPushNews();
            },
            onCancel() {
              console.log('Cancel');
            },
          });
        } else {
          message.error('信息填写页必填项未填写完整');
        }
      });
    }
  };

  fetchNewsPreview = () => {
    const { dispatch, selectedRow = [] } = this.props;
    const ids = [];
    selectedRow.forEach(item => {
      ids.push(item.id);
    });
    dispatch({
      type: 'microToPublic/fetchNewsPreview',
      params: {
        id: ids.join(','),
        appCode: getAppCode(),
      },
    })
      .then(() => {
        message.success('预览发布成功');
      })
      .catch(() => {
        dispatch({
          type: 'microToPublic/saveState',
          payload: { spinning: false },
        });
      });
  };

  fetchPushNews = () => {
    const { dispatch, selectedRow = [], form } = this.props;
    const { getFieldsValue } = form;
    const values = getFieldsValue();
    const { selectId, fromApp, isTiming, pushTime, selectIdType } = values;
    const ids = [];
    selectedRow.forEach(item => {
      ids.push(item.id);
    });

    dispatch({
      type: 'artcleLists/fetchPushNews',
      params: {
        id: ids.join(','),
        appCode: getAppCode(),
        selectIdType: selectIdType || 1,
        selectId,
        fromApp,
        isTiming,
        pushTime: moment(pushTime).format("YYYY-MM-DD HH:mm")
      },
    })
      .then(() => {
        message.success('推送成功');
        router.goBack();
        // this.resetTable();
      })
      .catch(() => {
        dispatch({
          type: 'microToPublic/saveState',
          payload: { spinning: false },
        });
      });
  };

  resetTable = () => {
    const { dispatch, params } = this.props;
    dispatch({
      type: 'microToPublic/saveState',
      payload: { spinning: false },
    });
    dispatch({
      type: 'microToPublic/fetchPublishList',
      params,
    })
      .then(res => {
        dispatch({
          type: 'microToPublic/saveState',
          payload: {
            dataSource: getLabelStrData(res),
            totalElements: res.totalElements,
            spinning: false,
            selectedRow: [],
            selectedRowKeys: [],
          },
        });
      })
      .catch(() => {
        dispatch({
          type: 'microToPublic/saveState',
          payload: { spinning: false },
        });
      });
  };

  nextStep = () => {
    const { activeKey } = this.state;
    this.setState({
      activeKey: `${Number(activeKey) + 1}`
    })
  };

  preStep = () => {
    const { activeKey } = this.state;
    this.setState({
      activeKey: `${Number(activeKey) - 1}`
    })
  };

  renderFooter = () => {
    const { selectedRow } = this.props;
    const selectedNum = selectedRow.length;
    const { activeKey } = this.state;
    const footerParams = {
      states: !0,
      demFooter: (
        <>
          <Button disabled={selectedNum === 0} onClick={this.fetchNewsPreview}>
            预 览
          </Button>
          {["2", "3"].indexOf(activeKey) > -1 && (
            <Button type="default" onClick={this.preStep}>
              上一步
            </Button>
          )}
          {["1", "2"].indexOf(activeKey) > -1 && (
            <Button type="primary" onClick={this.nextStep}>
              下一步
            </Button>
          )}

          {
            activeKey === '3' && (
              <Button type="primary" onClick={() => this.confirmPush()}>
                推送
              </Button>
            )
          }
        </>
      ),
    };
    return footerParams;
  };

  renderRangeSelectUserLabel = () => {
    return (
      <Tooltip
        placement="top"
        title="从已有系统标签规则选择组织精准推送"
        autoAdjustOverflow
      >
        系统标签内组织精准推送
        <Icon type="question-circle" style={{ marginLeft: 4 }} />
      </Tooltip>
    );
  };


  handleSetRangeList = data => {
    const { groupInfoList = [], orgRelInfoList = [], tagInfoList = [] } = data;
    this.setState({
      groupInfoList,
      orgRelInfoList,
      tagInfoList
    })
  }

  changeLabelType = e => {
    const { dispatch, formData, form } = this.props;
    form.setFieldsValue({
      selectId: '',
      electIdType: e.target.value,
    });
    // dispatch({
    //   type: 'microToPublic/saveState',
    //   payload: {
    //     formData: {
    //       ...formData,
    //       selectIdType: e.target.value,
    //       selectId: '',
    //     },
    //   },
    // });
  };

  render() {
    const { spinning, form, currentUser } = this.props;
    const { getFieldValue } = form;
    const { orgType } = currentUser || {};
    const { activeKey, pushTime, } = this.state;
    const customerFormItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };

    const labelTypeProps = {
      form,
      value: 5,
      label: '选择方式',
      keyName: 'selectIdType',
      isRequired: true,
      RadioGroupOptions:
        orgType === 'county'
          ? [
            { label: '本组织', value: 5 },
            { label: '按组织', value: 1 },
            { label: '按标签', value: 2 },
          ]
          : [
            { label: '本组织', value: 5 },
            { label: '指定人员范围', value: 4 },
          ],
      onChange: this.changeLabelType,
      itemFormProps:
        orgType === 'county'
          ? {
            labelCol: {
              span: 5,
            },
            wrapperCol: {
              span: 18,
            },
            style: { marginBottom: 16 },
          }
          : {
            style: { marginBottom: 16 },
          },
    };


    const selectOrganizationProps = {
      form,
      value: '',
      appName: '宣传管理',
      appId: 1,
      label: '组织选择',
      message: '选择需要发送的组织',
      keyName: 'selectId',
      isRequired: true,
      selectProps: {
        multiple: true,
        selectType: "dept",
        strictOrgRel: false,
        showTabList: ['orgRel'],
        dialogProps: {
          title: "选择对象",
        },
        searchPlaceholder: '搜索名称',
        selectSignature: '',
        isSaveSelectSignature: true,
        requestParams: {
          strictUser: true,
          selectTypeList: ['org_rel'],
        },
      },
      itemFormProps:
        orgType === 'county'
          ? {
            labelCol: {
              span: 5,
            },
            wrapperCol: {
              span: 18,
            },
          }
          : {},
    }

    const selectAreaProps = {
      form,
      value: '',
      appName: '宣传管理',
      appId: 1,
      label: '组织选择',
      message: '选择需要发送的组织',
      keyName: 'selectId',
      isRequired: true,
      selectProps: {
        selectType: "user",
        unCheckableNodeType: ["ORG"],
        showTabList: ["dept", "innerContacts", "schoolContacts", "tags"],
        dialogProps: {
          title: "选人组件"
        },
        selectSignature: "",
        isSaveSelectSignature: true,
        requestParams: {
          strictUser: true,
          tagTypeList: ["0", "1"],
          selectTypeList: ["user", "dept", "org", "group", "tags"]
        },
      },
      itemFormProps:
        orgType === 'county'
          ? {
            labelCol: {
              span: 5,
            },
            wrapperCol: {
              span: 18,
            },
          }
          : {},
    }

    const rangeSelectUserProps = {
      form,
      value: '',
      appName: "宣传管理",
      appId: 1,
      label: this.renderRangeSelectUserLabel(),
      message: "选择需要发送的组织",
      keyName: "selectId",
      isRequired: true,
      funCallbackSignature: data => this.handleSetRangeList(data),
      title: '推送范围',
      tagProps: {
        subtitle: '已选对象',
        btnText: '选择',
        btnDetele: true,
      },
      orgRelProps: {
        subtitle: '已选对象',
        btnText: '选择',
        btnDetele: true,
        showTabList: ['orgRel'],
        requestParams: {
          selectTypeList: ['org_rel',]
        }
      },
      itemFormProps: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18
        }
      }
    };

    const fromAppProps = {
      form,
      value: 17,
      label: '推送应用',
      keyName: 'fromApp',
      isRequired: true,
      optionData: [
        { value: 17, label: '微官网' },
        { value: 18, label: '活动打卡' },
      ],
    };

    const remindTimeProps = {
      form,
      value: '0',
      label: '推送时间',
      keyName: 'isTiming',
      isRequired: true,
      RadioGroupOptions: [
        { label: '立即推送', value: '0' },
        { label: '定时推送', value: '1' },
      ],
    };

    const timeProps = {
      form,
      value: moment(pushTime, "YYYY.MM.DD HH:mm"),
      label: '定时推送时间',
      keyName: 'pushTime',
      message: '定时推送时间',
      showTime: { defaultValue: moment("00:00", "HH:mm") },
      datePickerFormat: "YYYY-MM-DD HH:mm",
      tips: '说明: 推送可能因为网络原因延迟，请确认推送记录是否存在记录，请勿重复推送，定时发送的内容保存至操作记录-推送记录处',
    };

    const disabledDate = current => {
      // Can not select days before today and today
      return current && current < moment().startOf("day");
    };


    return (
      <Container breStates={!0} version={2} defaultPadding footerParams={this.renderFooter()}>
        <div className={styles.root}>
          <FormCreate customerFormItemLayout={customerFormItemLayout}>

            <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={this.changeTab}>
              <TabPane tab={this.renderTabTitle(activeKey, '资讯选择', '1')} key="1">
                <Spin spinning={spinning}>
                  <div className="content">
                    <section className="left">
                      <SelectList type="batchPush" />
                    </section>
                    <section className="right">
                      <ArticleTable type="batchPush" />
                    </section>
                  </div>
                </Spin>
              </TabPane>
              <TabPane tab={this.renderTabTitle(activeKey, '补推对象', '2')} key="2">
                <FormRadioGroup {...labelTypeProps} />
                {
                  getFieldValue('selectIdType') === 1 && <SelectUserVersion4 {...selectOrganizationProps} />
                }
                {
                  getFieldValue('selectIdType') === 4 && <SelectUserVersion4 {...selectAreaProps} />
                }
                {
                  getFieldValue('selectIdType') === 2 && <RangeSelectUser {...rangeSelectUserProps} />
                }
              </TabPane>
              <TabPane tab={this.renderTabTitle(activeKey, '发送属性', '3')} key="3">
                {orgType !== 'school' && Number(getAppCode()) === 1 && <FormSelect {...fromAppProps} />}
                <FormRadioGroup {...remindTimeProps} />
                {
                  Number(getFieldValue("isTiming")) === 1 && <DateAndTime disabledDate={disabledDate} {...timeProps} />
                }
              </TabPane>
            </Tabs>

          </FormCreate>
        </div>
      </Container>
    );
  }
}

export default BatchPush;
